import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=EB+Garamond:ital,wght@0,400;0,500;1,400&display=swap');

  :root {
    color-scheme: dark;
  }

  * { box-sizing: border-box; }

  html, body {
    height: 100%;
    margin: 0;
    background: ${({ theme }) => theme.colors.bg0};
    color: ${({ theme }) => theme.colors.text};
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
    font-weight: 400;
  }

  a { color: ${({ theme }) => theme.colors.gold}; text-decoration: none; }
  a:hover { text-decoration: underline; }

  :focus { outline: none; }
  :focus-visible {
    outline: 2px solid rgba(210,180,91,0.55);
    outline-offset: 2px;
    border-radius: 4px;
  }

  code, pre {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }
`;
